import TransitionText from "../components/TransitionText";
import { projects } from "../const/data";
import { dict } from "../const/dict";

const Projects = () => {
  return (
    <div className="section page-container">
      <div className="flex-col justify-start">
        <TransitionText text={dict.projects} wrapperClassName="justify-center" />
        <p className="text-description mt-5 text-center">
          {dict.projects1}
          <br />
          {dict.projects2}
          <br />
          {dict.projects3}
          <br />
          {dict.projects4}
          <br />
          {dict.projects5}
        </p>
        <div className="xl:flex gap-8 mt-8 hidden">
          {projects.map((item, index) => (
            <div
              role="button"
              key={item.imgSrc}
              onClick={() => window.open(item.url, "_blank")}
              className={`image-transition flex h-full ${
                index % 2 === 0 ? "flex-col" : "flex-col-reverse justify-end"
              }`}
            >
              <div>
                <p className="text-2xl font-semibold">{item.title}</p>
                <p className="text-description">{item.text}</p>
              </div>
              <img
                src={require(`../assets/images/projects/${item.imgSrc}.png`)}
                className="mt-2"
                alt={item.title}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
